const FIELDS = {
  taxResidencies: {
    label: 'Tax Residency',
    tooltip: 'The tax identification numbers for the countries that you pay tax in',
  },
}

export default FIELDS
